import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import BaseUrl from "../../../base-api";

export const useNotifications = (location = "All") => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchNotifications = useCallback(async () => {
    if (!location) return;

    setLoading(true);
    try {
      const res = await axios.post(
        `${BaseUrl}/api/notifications/getNotification`,
        { location },
        {
          headers: { "Content-Type": "application/json" },
          timeout: 80000,
        }
      );

      if (res.data.status === 200 && Array.isArray(res.data.data?.content)) {
        const content = res.data.data.content;
        setNotifications(
          content.map((item) => ({
            id: item.key,
            title: item.title,
            title_Hindi: item.title_Hindi,
            location: item.location,
            hasFile: item.file !== null,
            link: item.link || null,
            created: item.created || null
          }))
        );
      } else {
        setNotifications([]);
      }
    } catch (error) {
      console.error("Notifications failed:", error);

    } finally {
      setLoading(false);
    }
  }, [location]);

  useEffect(() => {
    fetchNotifications();
  }, [fetchNotifications]);

  const handleNotificationClick = async (notification) => {
    if (!notification.hasFile) {
      try {
        const res = await axios.get(
          `${BaseUrl}/api/notifications/document/${notification.id}`,
          {
            responseType: "blob",
            timeout: 80000,
          }
        );

        const fileBlob = new Blob([res.data], { type: res.headers["content-type"] });
        const fileUrl = URL.createObjectURL(fileBlob);
        window.open(fileUrl, "_blank");
      } catch (error) {
        console.error("Document fetch failed:", error);
        toast.error("फ़ाइल लोड नहीं हो सकी");
      }
    } else if (notification.link) {
      window.open(notification.link, "_blank");
    } else {
      toast.info("इस सूचना में कोई फ़ाइल या लिंक नहीं है");
    }
  };

  return { notifications, loading, handleNotificationClick };
};
